import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams } from 'react-router-dom'
import QueryString from 'query-string';
import ProductInfo from '../../Helpers/Data/Products/Americo/ProductInfo';
import { saveSessionEvent } from "../../../session";
import * as Steps from './steps';
import { HeaderStepper } from '../Common/HeaderStepper/HeaderStepper';
import ThankYou from '../Common/ThankYou';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY, getBasicInfo, SESSION_STORAGE_AMERICO_OBJECT_KEY, SESSION_STORAGE_COVR_FULLUW_KEY, SESSION_STORAGE_ACTIVE_PURL, SESSION_STORAGE_UTM_DATA } from '../../../sessionStorage';
import GetProductTypeEnum from '../../../types/productType';
import validateBMI from "./Helpers/ValidateBMI";
import GetProductDetail from "../../Common/GetProductDetail";

export default function Americo(props) {

  useEffect(() => { saveSessionEvent() }, [props.location])

  const product = ProductInfo();

  const { path } = useParams();

  const SESSION_STORAGE_KEY = "AMERICO_QUOTE";

  const sessionStorageFormState = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY));

  const prefill = props.location && props.location.search && props.location.search.toLowerCase().includes('prefill')

  const basicInfo = getBasicInfo();
  const mctQuoterData = getSessionStorageItem(SESSION_STORAGE_AMERICO_OBJECT_KEY);
  const getActivePurlData = getSessionStorageItem(SESSION_STORAGE_ACTIVE_PURL);
  const isActivePurl = getActivePurlData ? getActivePurlData.active : false;
  const accountId = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.accountId;

  if (props.landing && sessionStorageFormState) {
    sessionStorageFormState.currentStep = 1;
  }

  const loanProtProductSettings = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).accountProducts.find(accPrd => accPrd.productTypeId === GetProductTypeEnum().AmericoLoanProtector);

  const newDefaultFormState = {
    currentStep: 1,
    policyNumber: "",
    relatedFinancialInstitution: getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.accountName,
    submittingAgentCode: loanProtProductSettings ? loanProtProductSettings.submittingAgentCode : 'CVR99B ',
    steps: {
      basicInfo: Steps.BasicInfo.DefaultFormState(prefill, basicInfo, false, mctQuoterData, isActivePurl),
      quoter: Steps.Quoter.DefaultFormState(prefill, basicInfo, mctQuoterData),
      personalInfo: Steps.PersonalInfo.DefaultFormState(prefill, basicInfo),
      gettingToKnowYou: Steps.GettingToKnowYou.DefaultFormState(prefill, basicInfo),
      identityVerification: Steps.IdentityVerification.DefaultFormState(prefill, basicInfo),
      beneficiary: Steps.Beneficiary.DefaultFormState(prefill),
      personalHistory: Steps.PersonalHistory.DefaultFormState(prefill),
      medicalHistory: Steps.MedicalHistory.DefaultFormState(prefill, mctQuoterData),
      agreementToUnderwriting: Steps.AgreementToUnderwriting.DefaultFormState(prefill),
      policyPurposeConfirmation: Steps.PolicyPurposeConfirmation.DefaultFormState(prefill),
      financialInformation: Steps.FinancialInformation.DefaultFormState(prefill),
      appointment: Steps.Appointment.DefaultFormState(prefill, basicInfo),
    },
    adminMode: false,
    adminCode: "",
    decisionResponse: null,
    fieldsChangedAfterUnderwriting: [],
    oneClickAccountId: getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.oneClickAccountId,
    consumerAccountId: getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.accountId,
  };
  
  const initialFormState = sessionStorageFormState || newDefaultFormState;
  const mctFlowPages =getSessionStorageItem(SESSION_STORAGE_COVR_FULLUW_KEY);

  const [formState, setFormState] = useState(initialFormState);

  useEffect(() => {
    const productDetail = GetProductDetail(['/landing/loan-protection', '/loan-protection']);
    const redirectPath = productDetail === undefined ? '/' : '/landing/loan-protection';
    props.history.push(redirectPath);
  }, [])

  // update the formState when the url path changes the step
  useEffect(
    () => {
      if (!path) {
        return;
      }

      const nextStep = steps.find(s => s.path === path);

      // prevent submitted app alterations
      if (!sessionStorageFormState && formState.currentStep === (steps.length - 2)) {

        // if they are backing or directly going to another step, send them to product root
        if (formState.currentStep !== nextStep.step) {
          window.location = '/quote/term-life-insurance/loan-protector'
        }
      }

      if (formState.currentStep === 13 && formState.currentStep > nextStep.step) {
        window.location = '/quote/term-life-insurance/loan-protector/offer'
      }

      if (!nextStep || formState.currentStep === nextStep.step) {
        return;
      }
      const newFormState = { ...formState, currentStep: nextStep.step };
      setFormState(newFormState);
    }, [path])

  const getHealthClassfromBMI = (bmi) => {
    if (bmi < 30)
      {return 'best';}
    else if (bmi >= 30 && bmi < 36)
      {return 'better';}
    else if (bmi >= 36 && bmi < 40)
      {return 'good';}
    else
      {return 'better';}
  }

  const onNext = () => {
    const nextStep = steps.find(s => s.step === formState.currentStep + 1);

    if (!nextStep) {
      throw new Error("onNext did not find a next step");
    }

    const newFormState = { ...formState, currentStep: nextStep.step };

    if (formState.currentStep === 1 && formState.steps.basicInfo.bmi !== undefined && formState.steps.quoter.healthClass === '') {
      newFormState.steps.quoter.healthClass = getHealthClassfromBMI(formState.steps.basicInfo.bmi);
    }

    // save email from basicInfo to personalInfo
    if (formState.currentStep === 1) {
      newFormState.steps.personalInfo.emailAddress = newFormState.steps.basicInfo.email;
    }

    // save email from personalInfo to basicInfo
    if (formState.currentStep === 4) {
      newFormState.steps.basicInfo.email = newFormState.steps.personalInfo.emailAddress;
    }

    setFormState(newFormState);
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(newFormState));
    const newForm = mctQuoterData ? {...newFormState, logoUrl :mctQuoterData.logoUrl, mctQuoterData : mctQuoterData, mctFlowData : mctFlowPages } : newFormState
    newFormState.UTMs = getSessionStorageItem(SESSION_STORAGE_UTM_DATA) || "";
    fetch(`api/ConsumerApplication/Post?accountId=${ accountId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
      },
      body: JSON.stringify(newForm),
    });

    if (nextStep.step === 5) {
      saveSessionEvent(true);
    }

    props.history.push(`/quote/term-life-insurance/loan-protector/${nextStep.path}`);
    window.scroll(0, 0);
  }

  const setPolicyNumber = (value) => {
    setFormState({ ...formState, policyNumber: value });
  };

  const handlePaymentComplete = (appId, policyEffectiveDate) => {
    setFormState({ ...formState, appIdentifier: appId, policyEffectiveDate: policyEffectiveDate });
  };

  const handleApprovedPremiumUpdate = (oldPremium, newPremium) => {
    setFormState({ ...formState, originalPremium: oldPremium, steps: { ...formState.steps, quoter: { ...formState.steps['quoter'], premium: newPremium } } });
  };

  const onBack = () => {
    if (formState.currentStep <= 1) {
      window.location.replace('/');
    }

    const backStep = steps.find(s => s.step === formState.currentStep - 1);
    if(mctQuoterData!==null && backStep.path === 'get-a-quote'){
      if(mctQuoterData.backUrl){
        props.history.push(mctQuoterData.backUrl);
      }
      else
      {props.history.push('/quote/term-life-insurance/multi-carrier-term/get-a-quote');}   
      return 
    }
    if (!backStep) {
      throw new Error("onBack did not find a previous step");
    }

    const newFormState = { ...formState, currentStep: backStep.step };

    setFormState(newFormState);
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(newFormState));

    props.history.push(`/quote/term-life-insurance/loan-protector/${backStep.path}`);
    window.scroll(0, 0);
  };

  const onFieldChange = (step, field, value) => {
    if(step === 'basicInfo' && field === 'tobacco'){
      const form = formState;
      form.steps.medicalHistory.nicotineUse = value;
      setFormState(form);
    }
    setFormState({ ...formState, steps: { ...formState.steps, [step]: { ...formState.steps[step], [field]: value } } });
  };

  const goToStep = (path) => {
    const nextStep = steps.find(s => s.path === path);
    if (!nextStep) {
      throw new Error("goToStep did not find a next step")
    }

    const newFormState = { ...formState, currentStep: nextStep.step };

    setFormState(newFormState);
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(newFormState));

    props.history.push(`/quote/term-life-insurance/loan-protector/${nextStep.path}`);
    window.scroll(0, 0);
  }

  const getHeaderText = () => {
    const currentStep = formState.currentStep;
    if (currentStep === 1 || currentStep === 2) {
      return "Americo LoanMatch Protector";
    } else if (currentStep === 13) {
      return "Let's get the best quote for you";
    } else if (currentStep === 18) {
      return "Verifying Your Information";
    }
    else {
      return "LoanMatch Protector";
    }
  }

  const termCardsOnNextApply = (productId) => {

    // covr quoter digital product ids
    const HAVEN_TERM_PRODUCT_ID = 1031;
    const BESTOW_PRODUCT_ID = 1032;
    const LGA_PRODUCT_ID = 1033;

    if (productId === HAVEN_TERM_PRODUCT_ID || productId === BESTOW_PRODUCT_ID || productId === LGA_PRODUCT_ID) {
      sessionStorage.setItem(SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY, formState.steps.quoter.coverageAmount);
      window.location = '/quote/term-life-insurance/multi-carrier-term';
    } else {
      goToStep('appointment');
    }

  }

  const ageSpecs = { min: 18, max: 70 }

  // hook onNextApply
  const steps = [
    {
      step: 1,
      path: 'basic-info',
      progressTitle: 'Basic Information',
      component: (
        <Steps.BasicInfo
          formState={formState.steps.basicInfo}
          onFieldChange={(field, value) => onFieldChange('basicInfo', field, value)}
          onNext={onNext}
          queryString={props.location ? QueryString.parse(props.location.search) : null}
          hideBack={props.landing}
          ageSpecs={ageSpecs}
          onBack={onBack}
          onDeclined={() => goToStep('ineligible')}
          unavailableStates={["NY", "VI"]}
          validateBMI={(totalHeight, bmi, weight) => validateBMI(totalHeight, bmi, weight)}
          tobaccoOptions={
            [
              { label: "Within the last year", value: "Within the last year" },
              { label: "Within the last 13-36 months", value: "Within the last 13-36 months" },
              { label: "Over 36 months ago", value: "Over 36 months" },
              { label: "Never", value: "Never" },
            ]
          }
          tobaccoToTrueFalseString={(value) => (value !== 'Never').toString()}
        />
      ),
      hideProgressTracker: true,
    },
    {
      step: 2,
      path: 'get-a-quote',
      progressTitle: 'Get a Quote',
      component: (
        <Steps.Quoter
          onBack={onBack}
          onNext={onNext}
          queryString={props.location ? QueryString.parse(props.location.search) : null}
          product={product}
          formState={formState.steps.quoter}
          basicInfo={formState.steps.basicInfo}
          onFieldChange={(field, value, _step) => onFieldChange(_step || 'quoter', field, value)}
          onNextApply={termCardsOnNextApply}
        />
      ),
      hideProgressTracker: true,
    },
    {
      step: 3,
      path: 'getting-started',
      progressTitle: 'Getting Started',
      component: (
        <Steps.GettingStarted
          onBack={onBack}
          onNext={onNext}
        />
      ),
      hideStepsDropdown: true,
    },
    {
      step: 4,
      path: 'proposed-insured-info',
      component: (
        <Steps.PersonalInfo
          formState={formState.steps.personalInfo}
          basicInfo={formState.steps.basicInfo}
          onFieldChange={(field, value) => onFieldChange('personalInfo', field, value)}
          onBack={onBack}
          onNext={onNext}
        />
      ),
      categoryNumber: 1,
      categoryName: 'Personal Information',
    },
    {
      step: 5,
      path: 'getting-to-know-you',
      component: (
        <Steps.GettingToKnowYou
          formState={formState.steps.gettingToKnowYou}
          basicInfo={formState.steps.basicInfo}
          onFieldChange={(field, value) => onFieldChange('gettingToKnowYou', field, value)}
          onBack={onBack}
          onNext={onNext}
          onEditBasicInfo={() => goToStep('basic-info')}
          ageSpecs={ageSpecs}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          fullFormState={formState}
        />
      ),
      categoryNumber: 1,
      categoryName: 'Personal Information',
    },
    {
      step: 6,
      path: 'identity-verification',
      component: (
        <Steps.IdentityVerification
          formState={formState.steps.identityVerification}
          basicInfo={formState.steps.basicInfo}
          onFieldChange={(field, value) => onFieldChange('identityVerification', field, value)}
          onBack={onBack}
          onNext={onNext}
        />
      ),
      categoryNumber: 1,
      categoryName: 'Personal Information',
    },
    {
      step: 7,
      path: 'personal-history',
      component: (
        <Steps.PersonalHistory
          formState={formState.steps.personalHistory}
          onFieldChange={(field, value) => onFieldChange('personalHistory', field, value)}
          onBack={onBack}
          onNext={onNext}
          basicInfo={formState.steps.basicInfo}
        />
      ),
      categoryNumber: 2,
      categoryName: 'Lifestyle and Medical History',
    },
    {
      step: 8,
      path: 'medical-history',
      component: (
        <Steps.MedicalHistory
          formState={formState.steps.medicalHistory}
          onFieldChange={(field, value) => onFieldChange('medicalHistory', field, value)}
          onBack={onBack}
          onNext={onNext}
          basicInfo={formState.steps.basicInfo}
          fullFormState={formState}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
        />
      ),
      categoryNumber: 2,
      categoryName: 'Lifestyle and Medical History',
    },
    {
      step: 9,
      path: 'beneficiary',
      component: (
        <Steps.Beneficiary
          formState={formState.steps.beneficiary}
          onFieldChange={(field, value) => onFieldChange('beneficiary', field, value)}
          onBack={onBack}
          onNext={onNext}
          maritalStatus={formState.steps.gettingToKnowYou.maritalStatus}
        />
      ),
      categoryNumber: 3,
      categoryName: 'Policy Beneficiary',
    },
    {
      step: 10,
      path: 'policy-purpose-confirmation',
      component: (
        <Steps.PolicyPurposeConfirmation
          formState={formState.steps.policyPurposeConfirmation}
          fullFormState={formState}
          onFieldChange={(field, value) => onFieldChange('policyPurposeConfirmation', field, value)}
          onBack={onBack}
          onNext={onNext}
          setPolicyNumber={setPolicyNumber}
          onDeclined={() => goToStep('ineligible')}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          history={props.history}
        />
      ),
      categoryNumber: 4,
      categoryName: 'Disclosures and Agreements',
    },
    {
      step: 11,
      path: 'agreement-to-underwriting',
      component: (
        <Steps.AgreementToUnderwriting
          formState={formState.steps.agreementToUnderwriting}
          onFieldChange={(field, value) => onFieldChange('agreementToUnderwriting', field, value)}
          onBack={onBack}
          onNext={onNext}
          fullFormState={formState}
          basicInfo={formState.steps.basicInfo}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          history={props.history}
        />
      ),
      categoryNumber: 4,
      categoryName: 'Disclosures and Agreements',
    },
    {
      step: 12,
      path: 'underwriting-status',
      component: (
        <Steps.UnderwritingStatus
          formState={formState}
          onNext={onNext}
          onDeclined={() => goToStep('ineligible')}
          onDecision={(updatedFormState) => {
            setFormState({ ...updatedFormState });
          }}
          onFieldChange={onFieldChange}
        />
      ),
      categoryNumber: 5,
      categoryName: 'Offer and Payment',
    },
    {
      step: 13,
      path: 'offer',
      component: (
        <Steps.Offer
          quoter={formState.steps.quoter}
          basicInfo={formState.steps.basicInfo}
          onFieldChange={(field, value) => onFieldChange('quoter', field, value)}
          handleApprovedPremiumUpdate={handleApprovedPremiumUpdate}
          onBack={onBack}
          onNext={onNext}
          onCoverageChanged={(coverage) => {
            const changed = formState.fieldsChangedAfterUnderwriting;
            changed.push('coverage');
            setFormState({ ...formState, fieldsChangedAfterUnderwriting: changed });
          }}
        />
      ),
      categoryNumber: 5,
      categoryName: 'Offer and Payment',
    },
    {
      step: 14,
      path: 'payment-information',
      component: <Steps.FinancialInformation
        formState={formState.steps.financialInformation}
        fullFormState={formState}
        onFieldChange={(field, value) => onFieldChange('financialInformation', field, value)}
        onNext={onNext}
        onBack={onBack}
        handlePaymentComplete={handlePaymentComplete}
      />,
      categoryNumber: 5,
      categoryName: 'Offer and Payment',
    },
    {
      step: 15,
      path: 'sign',
      component: <Steps.Sign
        formState={formState}
        onNext={onNext}
        onBack={onBack}
      />,
      categoryNumber: 5,
      categoryName: 'Offer and Payment',
    },
    {
      step: 16,
      path: 'status',
      component: <Steps.Status
        formState={formState}
        onNext={onNext}
        onBack={onBack}
      />,
      categoryNumber: 5,
      categoryName: 'Coverage Activated',
      lastStep: true,
    },

    // not included in flow
    {
      step: 17,
      path: 'appointment',
      progressTitle: 'Appointment',
      component: <Steps.Appointment
        formState={formState.steps.appointment}
        quoter={formState.steps.quoter}
        basicInfo={formState.steps.basicInfo}
        product={`Loan Protection Life Insurance`}
        onFieldChange={(field, value) => onFieldChange('appointment', field, value)}
        onNext={() => goToStep('thank-you')}
        onBack={() => goToStep('get-a-quote')}
        isAppointmentSchedulingEnabled={loanProtProductSettings ? loanProtProductSettings.enableAppointmentScheduling : true}
        location={props.location}
        history={props.history}
        baseURL={'/quote/term-life-insurance/loan-protector/appointment'}
        setMultiField={(firstName, lastName, email) => {
          setFormState({ ...formState, pages: { ...formState.pages, appointment: { ...formState.pages.appointment, firstName: firstName, lastName: lastName, email: email } } })
          sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(formState));
        }}
        fullFormState={formState}
        onMultiFieldChange={(fs) => {setFormState(fs)}}
      />,
      hideProgressTracker: true,
      hideMainHeader: true,
    },
    {
      step: 18,
      path: 'thank-you',
      progressTitle: 'ThankYou',
      component: <ThankYou
        sessionStorageKey={SESSION_STORAGE_KEY}
        name={formState.steps.appointment.appointment}
        date={formState.steps.appointment.specificApptTime}
        basicInfo={formState.steps.basicInfo} />,
      hideProgressTracker: true,
      hideMainHeader: false,
    },
    {
      step: 19,
      path: 'ineligible',
      progressTitle: 'Ineligible',
      component: <Steps.Ineligible
        formState={formState.steps.quoter}
        basicInfo={formState.steps.basicInfo}
      />,
      hideProgressTracker: true,
    },
  ];

  const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];

  const categories = steps.filter((o) => typeof o.categoryNumber !== 'undefined');
  const totalCategories = Math.max(...categories.map((o) => { return o.categoryNumber; }));

  return (
    <div>
      <Helmet>
        <title>Loan Protector - {currentStepObj.categoryName || currentStepObj.progressTitle}</title>
      </Helmet>
      <HeaderStepper
        title={getHeaderText()}
        hidden={props.landing || currentStepObj.hideMainHeader}
        hideProgressTracker={currentStepObj.hideProgressTracker}
        stepName={currentStepObj.categoryName || currentStepObj.progressTitle}
        step={currentStepObj.categoryNumber || 0}
        totalSteps={totalCategories}
        lastStep={currentStepObj.lastStep}
        hideStepsDropdown={currentStepObj.hideStepsDropdown}>
        <div className="americoLoanProtector">
          {currentStepObj.component}
        </div>
      </HeaderStepper>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Americo/Americo.js